import { render, staticRenderFns } from "./Kingkong.vue?vue&type=template&id=474507c7&scoped=true&"
import script from "./Kingkong.vue?vue&type=script&lang=js&"
export * from "./Kingkong.vue?vue&type=script&lang=js&"
import style0 from "./Kingkong.vue?vue&type=style&index=0&id=474507c7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474507c7",
  null
  
)

export default component.exports